module.exports = {
      id: "filter-icon-usage",
      viewBox: "0 0 13 14",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#filter-icon",
      toString: function () {
        return this.url;
      }
    }